import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2447.js";
function t({ size: e = i }) {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ l("path", { d: "M18 16H31L38 23V39H18V16Z", fill: "white" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.334 16.6665V22.0367C31.334 22.751 32.4653 23.3332 33.0379 23.3332H38.0007",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.3119 16C31.588 16 31.8119 16.2239 31.8119 16.5V22.0227C31.8119 22.4815 32.1857 22.856 32.6452 22.856H38.1679C38.444 22.856 38.6679 23.0799 38.6679 23.356C38.6679 23.6321 38.444 23.856 38.1679 23.856H32.6452C31.6327 23.856 30.8119 23.0332 30.8119 22.0227V16.5C30.8119 16.2239 31.0357 16 31.3119 16Z",
            fill: "#676DFD"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.334 17.8333C17.334 16.8195 18.1555 16 19.1673 16H31.8358L38.6673 22.8316V38.1667C38.6673 39.1801 37.8475 40 36.834 40H19.1673C18.1555 40 17.334 39.1805 17.334 38.1667V17.8333ZM19.1673 17C18.7071 17 18.334 17.3725 18.334 17.8333V38.1667C18.334 38.6275 18.7071 39 19.1673 39H36.834C37.2952 39 37.6673 38.6279 37.6673 38.1667V23.2458L31.4215 17H19.1673Z",
            fill: "#676DFD"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.5 26.6486L30.7011 28.8497L31.4082 28.1426L28 24.7344L24.5918 28.1426L25.2989 28.8497L27.5 26.6486V33.5991H28.5V26.6486ZM24.0938 35.7335H31.9058V34.7335H24.0938V35.7335Z",
            fill: "#676DFD"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricUploadIcon
};
//# sourceMappingURL=index.es435.js.map
